import { useMemo } from 'react'
import { useGetWalletBalances } from 'hooks/queries/Wallets/useGetWalletBalances'
import { RewardsProduct } from 'types/rewards'

export const useEarningWalletBalances = (rewardsProducts: RewardsProduct[]) => {
  const { data: walletBalances, isLoading: isLoadingBalances } = useGetWalletBalances()

  const earningProductCurrencies = useMemo(() => {
    if (!rewardsProducts) return new Set<string>()
    return new Set(rewardsProducts.map(product => product.currency))
  }, [rewardsProducts])

  const filteredBalances = useMemo(() => {
    if (!walletBalances?.length || !earningProductCurrencies.size) return []
    return walletBalances?.filter(balance => earningProductCurrencies.has(balance.currency.code))
  }, [walletBalances, earningProductCurrencies])

  const totalAvailableByProduct = useMemo(() => {
    return filteredBalances.reduce(
      (acc, balance) => {
        const currencyCode = balance?.currency?.code
        acc[currencyCode] = (acc[currencyCode] || 0) + balance.available
        return acc
      },
      {} as Record<string, number>
    )
  }, [filteredBalances])

  return {
    totalAvailableByProduct,
    isLoading: isLoadingBalances,
  }
}
